<p-modal [open]="true" size="large" (closed)="closed.emit()">
  <p-modal-header-default title="Inspect column" />
  <div class="p-flex p-flex-col cell-zoom-content">
    @if (cellRenderer && page) {
    <cdk-table class="list-table cell-zoom-table" [dataSource]="[row]">
      <ng-container cdkColumnDef="rowNumber">
        <cdk-header-cell *cdkHeaderCellDef>Row</cdk-header-cell>
        <cdk-cell *cdkCellDef class="p-flex cell-zoom-row-control">
          <div class="p-flex-col-xxs p-flex-center">
            <p-button-icon-ghosted-sm icon="arrow-up" [disabled]="rowIndex === 0" (click)="showNext(false)" />
            <span class="p-text-desc">{{ page.rowNumber(rowIndex) | number }}</span>
            <p-button-icon-ghosted-sm
              icon="arrow-down"
              [disabled]="rowIndex >= page.rows.length - 1"
              (click)="showNext(true)"
            />
          </div>
        </cdk-cell>
      </ng-container>
      <ng-container cdkColumnDef="value">
        <cdk-header-cell *cdkHeaderCellDef>{{ column?.name }}</cdk-header-cell>
        <cdk-cell *cdkCellDef="let currentRow" class="cell-zoom-renderer">
          <div
            [pCellRenderer]="cellRenderer"
            [row]="currentRow"
            [rowIndex]="rowIndex"
            [column]="column"
            [value]="value"
            [page]="page"
            [addPopup]="false"
          ></div>
        </cdk-cell>
      </ng-container>
      <cdk-header-row *cdkHeaderRowDef="columns" />
      <cdk-row *cdkRowDef="let currentRow; columns: columns" />
    </cdk-table>
    }
  </div>
</p-modal>
